// inv/src/pages/payment/planExtraInfo.jsx
import { useTranslation } from 'react-i18next';

export default function PlansExtraInfo({ bgColor = 'mt-24 bg-custom1 w-full dark:bg-stone-900' }) {
  const { t } = useTranslation();

  return (
    <section>
      {/* Block 1: full-width bg */}
      <div className={`w-full ${bgColor}`}>
        <div className="max-w-7xl mx-auto px-16 sm:px-6 lg:px-16 py-16 sm:py-20 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-24 items-center">
            {/* Left Column: Image */}
            <div className="lg:col-span-7 order-2 lg:order-1">
              <img
                src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/pricing/crino-free-account-find-investors.gif"
                alt="Free Plan illustration"
                className="rounded-lg shadow-xl w-full h-auto object-cover"
              />
            </div>

            {/* Right Column: Content */}
            <div className="lg:col-span-5 order-1 lg:order-2">
              <div className="text-center lg:text-left">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-stone-950 mb-4 sm:mb-6">
                  {t('pagePricing.content.extraInfo.freePlan.title')}
                </h2>
                <p className="text-base sm:text-lg text-stone-950 mb-6 sm:mb-8 leading-relaxed">
                  {t('pagePricing.content.extraInfo.freePlan.description')}
                </p>
                <ul className="space-y-3 sm:space-y-4 text-stone-950">
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-600 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.freePlan.features.f1')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-600 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.freePlan.features.f2')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-600 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.freePlan.features.f3')}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Block 2: full-width bg */}
      <div className="w-full bg-custom3">
        <div className="max-w-7xl mx-auto px-16 sm:px-6 lg:px-16 py-16 sm:py-20 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            {/* Left Column: Content */}
            <div className="lg:col-span-6 order-2 lg:order-1">
              <div className="text-center lg:text-left">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6">
                  {t('pagePricing.content.extraInfo.proPlan.title')}
                </h2>
                <p className="text-base sm:text-lg text-white mb-6 sm:mb-8 leading-relaxed">
                  {t('pagePricing.content.extraInfo.proPlan.description')}
                </p>
                <ul className="space-y-3 sm:space-y-4 text-white">
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-white font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f1')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-400 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f2')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-400 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f3')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-400 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f4')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-400 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f5')}</span>
                  </li>
                  <li className="flex items-start sm:items-center">
                    <span className="mr-3 mt-0.5 sm:mt-0 text-green-400 font-bold">✔</span>
                    <span className="text-sm sm:text-base">{t('pagePricing.content.extraInfo.proPlan.features.f6')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="lg:col-span-6 order-1 lg:order-2">
              <img
                src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/pricing/crino-paid-features.png"
                alt="Pro Plan illustration"
                className="rounded-xl shadow-xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
